<template>
  <section class="billingSettings-page">
    <div class="d-inline-flex tabBorder">
      <div
        class="tab"
        v-for="(tab, i) of tabs"
        :key="i"
        :class="{ activeTab: activeTab === tab }"
        @click="activeTab = tab"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="billingSettings-page_tabView">
      <component
        :is="activeTab.component"
        :ref="activeTab.label === 'Overview' ? 'overview' : null"
      />
    </div>

    <Modal title="Unsaved Changes" v-model="unsavedModalVisible">
      <div class="modalContent">
        <p>You have unsaved changes. Do you want to leave without saving?</p>
        <div class="modalFooter">
          <el-button type="danger" @click="confirmLeave">Yes, leave</el-button>
          <el-button type="primary" @click="cancelLeave">No, stay</el-button>
        </div>
      </div>
    </Modal>
    <coming-soon-modal />
  </section>
</template>

<script>
import BillingContacts from "./tabs/BillingContacts.vue";
import PaymentMethods from "./tabs/PaymentMethod.vue";
import Invoices from "./tabs/Invoices.vue";
import Settings from "./tabs/Settings.vue";
import OverView from "./tabs/OverView.vue";
import Modal from "../../../Components/Modal.vue";
import { Button } from "element-ui";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  components: {
    ComingSoonModal,
    OverView,
    BillingContacts,
    PaymentMethods,
    Invoices,
    Settings,
    Modal,
    [Button.name]: Button,
  },
  data() {
    return {
      tabs: [
        { label: "Overview", component: "OverView" },
        { label: "Settings", component: "Settings" },
        { label: "Invoices", component: "Invoices" },
        { label: "Payment Method", component: "PaymentMethods" },
        { label: "Billing Contacts", component: "BillingContacts" },
      ],
      activeTab: null,
      unsavedModalVisible: false, // Controls display of the unsaved changes modal
      pendingNavigation: null, // Stores navigation callback from beforeRouteLeave
    };
  },
  computed: {
    isActive() {
      return (tab) => this.activeTab.label === tab.label;
    },
  },
  created() {
    this.activeTab = this.tabs[0];
  },
  beforeRouteLeave(to, from, next) {
    // If the active tab is Overview, check for unsaved changes in OverView
    if (this.activeTab.label === "Overview" && this.$refs.overview) {
      // When using v-for with refs, $refs.overview might be an array.
      const overviewComponent = Array.isArray(this.$refs.overview)
        ? this.$refs.overview[0]
        : this.$refs.overview;

      // If unsaved changes exist (saveDisabled is false), prompt the user.
      if (overviewComponent && !overviewComponent.saveDisabled) {
        this.pendingNavigation = next; // Save navigation callback
        this.unsavedModalVisible = true; // Show confirmation modal
        return;
      }
    }
    next();
  },
  methods: {
    confirmLeave() {
      this.unsavedModalVisible = false;
      if (this.pendingNavigation) {
        this.pendingNavigation(); // Proceed with navigation
      }
    },
    cancelLeave() {
      this.unsavedModalVisible = false;
      if (this.pendingNavigation) {
        this.pendingNavigation(false); // Cancel navigation
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modalContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.modalFooter {
  display: flex;
  justify-content: space-evenly;
}
.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}
/* Tab styling */
.tab:hover {
  cursor: pointer;
}

.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}

.tab {
  position: relative;
  padding: 15px 25px;
  font-size: 16px;
}

.tab:focus-within {
  border-bottom: 2px solid #3c78ff;
}

.tab.activeTab::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #3c78ff;
}
.billingSettings-page {
  padding: 50px;
  &_tabs {
    button {
      color: #404040;
      text-align: center;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      background: none;
      border-radius: 0;
      border-bottom: 2px solid rgba(64, 64, 64, 0.25);
      transition: none;
      padding-bottom: 15px;

      &.active {
        border-bottom: 2px solid #3c78ff;
      }
    }
  }
}
</style>
